
import { 
    GET_STANDARD_STOPS__URL , 
    CREATE_ADDRESS_LOCATION_URL , 
    UPDATE_ADDRESS_LOCATION_URL, 
    DELETE_ADDRESS_LOCATION_URL,
    GET_BRANCH_OFFICES_URL
} from "./../utils/api-url";
import { postCall } from "../utils/network.util";
import { isValid } from "../utils/utilities";
import { GET_STANDARD_STOPS } from "./action-types";

export const getStandardStops=()=>{
        return{
          type:GET_STANDARD_STOPS,
          payload: {
              url:GET_STANDARD_STOPS__URL,
              api:postCall,
              apiPayload:{
                cities:[]
              }
          }
      }
}


export const getStandardStopsForCities=(cities,onSuccess=()=>{},onFailure=()=>{})=>{
  var created = postCall(GET_STANDARD_STOPS__URL, {cities:cities});
      created.then((data) => {
      if(data.status === "SUCCESS" && data.payload.Status === "SUCCESS"){
          onSuccess(data.payload.Payload);
      }else{
        onFailure(data.payload.Message);
      }
    })
    .catch((reason)=> {
      onFailure("Failed to create address");
    })
}

export const createAddressLocation=(values,onSuccess=()=>{},onFailure=()=>{})=>{
    postCall(CREATE_ADDRESS_LOCATION_URL, {location:values})
      .then((data) => {
        // Resolve the response first, then invoke onSuccess in the next .then - so a throw
        // inside onSuccess isn't caught here and misreported as an address-creation failure.
        if(data.status === "SUCCESS" && isValid(data.payload) && data.payload.Status === "SUCCESS"){
          return { ok: true, id: data.payload.Payload[0] };
        }
        return { ok: false, message: isValid(data.payload) ? data.payload.Message : null };
      }, () => {
        return { ok: false, message: "Failed to create address" };
      })
      .then((result) => {
        if(result.ok){
          onSuccess(result.id);
        }else{
          onFailure(result.message || "Failed to create address");
        }
      });
}

export const updateAddressLocation=(location,onSuccess=()=>{},onFailure=()=>{})=>{
    postCall(UPDATE_ADDRESS_LOCATION_URL, {location:location})
      .then((data) => {
        // Resolve the network response first; invoke onSuccess only in the next
        // .then so a throw inside onSuccess is not misreported as an update failure.
        if(data.status === "SUCCESS" && isValid(data.payload) && data.payload.Status === "SUCCESS"){
          return { ok: true };
        }
        return { ok: false, message: isValid(data.payload) ? data.payload.Message : null };
      }, () => {
        return { ok: false, message: "Failed to update addresses" };
      })
      .then((result) => {
        if(result.ok){
          onSuccess();
        }else{
          onFailure(result.message || "Failed to update addresses");
        }
      });
}

export const deleteAddressLocation=(locationId,onSuccess=()=>{},onFailure=()=>{})=>{
    var deleted = postCall(DELETE_ADDRESS_LOCATION_URL, {locationId});
    deleted.then((data) => {
        if(data){
            onSuccess();
        }else{
          onFailure(data.payload.Message);
        }
      })
      .catch((reason)=> {
        onFailure("Failed to delete addresses");
      })
}

export const getBranchOffices= (onSuccess=()=>{},onFailure=()=>{}) => {
  var created = postCall(GET_BRANCH_OFFICES_URL, {operatorCode:global.operatorCode});
  created.then((data) => {
    if(data.status === "SUCCESS" && data.payload.Status === "SUCCESS"){
      onSuccess(data.payload.Payload);
    }else{
      onFailure(data.payload.Message);
    }
  })
  .catch((reason)=> {
    onFailure("Failed to get branch offices");
  })
}